import React,{Component} from 'react';
import PropTypes from 'prop-types'
import PersonalSecurePlans from '../../Pages/PersonalSecurePlans'

class Popover extends Component{
    constructor(){
        super();
        this.state = {
            open: false
        }
        this.onHover = this.onHover.bind(this);
        this.onLeave = this.onLeave.bind(this);
    }
    onHover(e){
        e.preventDefault();
        this.setState({
            ...this.state,
            open: true
        })
    }
    onLeave(e){
        e.preventDefault();
        this.setState({
            ...this.state,
            open: false
        })
    }
    render(){
        const {onHover,onLeave} = this;
        const {open} = this.state;
        return (
            <div className={`SSL-Selector__popover clearfix`} onMouseEnter={onHover} onMouseLeave={onLeave}>
                <div className={`popover__text`}>subdomains</div>
                {open?
                    <div className={`popover__baloon`}>
                        <div className={`baloon__description clearfix`}>
                            A Sub domain is a subset of your domain name that allows you to send visitors to a different website without having to purchase a seperate domain name.
                        </div>
                        <div className={`baloon__domainname clearfix`}>
                            <div className={`domainname__sub`}>store.</div>
                            <div className={`domainname__name`}>domain.com</div>
                        </div>
                    </div>
                :""}
            </div>
        )
    }
}

PersonalSecurePlans.propTypes ={
    onHover: PropTypes.function,
    onLeave: PropTypes.function
}

export default Popover;
